import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal";
import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { unique } from "@Shared/@Utils/validation-rules";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SaveChecklistModal",
  components: {
    GenericModal,
    MaterialInput,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    templateName: {
      required,
      unique: function (value) {
        return unique(this.checklistTemplateNames)(value);
      }
    }
  },
  props: {
    checklistTemplates: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateName: ""
    };
  },
  computed: {
    checklistTemplateNames() {
      var _context;
      return _mapInstanceProperty(_context = _Object$values(this.checklistTemplates)).call(_context, template => template.title);
    }
  },
  watch: {
    loading(loading, wasLoading) {
      if (wasLoading && !loading) {
        this.$hideModal();
      }
    }
  },
  methods: {
    handleSaveTemplate() {
      if (this.$v.$invalid) return;
      this.$emit("submit", this.templateName);
    },
    handleHide() {
      this.$nextTick(() => {
        this.templateName = "";
      });
      this.$emit("hide");
    }
  }
});